module.exports = __webpack_public_path__ + "static/scrum5minutes-54ea6fa552d434d5c166cba939b15bd6.jpg";